<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="东盟矿业列表" name="1">
      <DmkyAdd :updataID='updataID'></DmkyAdd>
    </el-tab-pane>
    <el-tab-pane label="分类管理列表" name="2"></el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * 安进
 * 东盟矿业修改
 */
import DmkyAdd from '../../../../static/form/DmkyAdd.vue'
export default {
  components: {
    DmkyAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Dmkygl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/DmkyUpdate.vue